export default __webpack_public_path__ + "static/media/1970.a37daae4.png";